import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Markdown from "markdown-to-jsx";
import { getMarkdownContent } from "../Fetching";
import { useTranslation } from "react-i18next";

const Article = () => {
  const navigate = useNavigate();
  const { artID } = useParams(); // 🔹 artID az URL-ből jön pl. /article/ai101
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const language = query.get("lang") || "en"; // 🔹 ?lang=en query paraméterből

  const [markdownContent, setMarkdownContent] = useState("");
  const topButtonRef = useRef(null);
  const { t } = useTranslation();

  // 🔹 Cikk tartalom betöltése
  useEffect(() => {
    if (!artID) return;
    getMarkdownContent(artID, language)
      .then((content) => setMarkdownContent(content))
      .catch((err) => console.error("Hiba a markdown lekérésekor:", err));
  }, [artID, language]);

  // 🔹 "Go to Top" gomb viselkedés
  useEffect(() => {
    const mybutton = topButtonRef.current;
    if (!mybutton) return;

    const scrollFunction = () => {
      mybutton.style.display = window.scrollY > 100 ? "block" : "none";
    };
    const topFunction = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", scrollFunction);
    mybutton.addEventListener("click", topFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
      mybutton.removeEventListener("click", topFunction);
    };
  }, []);

  // 🔹 Ha nincs tartalom (vagy még tölt)
  if (!markdownContent) {
    return (
      <div className="main-content article-content px-4 md-3">
        <p>{t("NoContent") || "No content available."}</p>
      </div>
    );
  }

  // 🔹 Megjelenítés
  return (
    <div className="main-content article-content px-4 md-3">
      {/* Scroll to Top gomb */}
      <button
        ref={topButtonRef}
        id="TopBtn"
        title="Go to top"
        style={{ display: "none" }}
      >
        &#10224;
      </button>

      {/* Markdown renderelés */}
      <Markdown>{markdownContent}</Markdown>

      {/* Vissza gomb */}
      <button
        onClick={() => navigate(-1)}
        className="btn btn-secondary my-3"
      >
        {t("BackButton") || "Back"}
      </button>
    </div>
  );
};

export default Article;
